import React from "react";

function PintaPortfolio({ onBack }) {
    return (
        <div className="pinta-portfolio-container">
            <button
                onClick={onBack}
                className="button-back"
            >
                Volver a PintaMKT
            </button>
            <iframe
                src="https://pintamkt.myportfolio.com/"
                style={{
                    width: "100%",
                    height: window.innerWidth <= 768 ? "95vh" : "85vh",
                    border: "none",
                }}
                title="Pinta Portfolio"
            ></iframe>
        </div>
    );
}

export default PintaPortfolio;
